import { Children, useMemo } from "react";
import { isValidActionBarItem } from "../guards.js";
function useActionItems(params) {
  const { children, limit = Number.POSITIVE_INFINITY, hiddenCount } = params;
  return useMemo(() => {
    const arr = Children.toArray(children).filter(isValidActionBarItem);
    if (arr.length !== Children.count(children)) {
      console.warn("ActionBar only accepts ActionBarItem as children.", "Other children are not rendered");
    }
    const buttonItems = arr.filter((x) => x.props.mode === "default" || x.props.mode === void 0);
    const menuItems = arr.filter((x) => x.props.mode === "menu");
    if (limit === "auto" && hiddenCount > 0) {
      menuItems.push(...buttonItems.slice(-hiddenCount));
    }
    if (typeof limit === "number") {
      if (limit <= 0) {
        menuItems.push(...buttonItems.splice(0));
      } else if (buttonItems.length > limit) {
        menuItems.push(...buttonItems.splice(limit));
      }
    }
    const endItems = arr.filter((x) => x.props.mode === "end");
    if (endItems.length > 1) {
      console.warn('ActionBar only accepts on child with mode="end"', "Additional items will be added to the menu.");
    }
    const endItem = endItems.shift();
    menuItems.push(...endItems);
    const showMenu = menuItems.length > 0;
    return {
      buttonItems,
      endItem,
      menuItems,
      showMenu
    };
  }, [children, limit, hiddenCount]);
}
export {
  useActionItems
};
//# sourceMappingURL=useActionItems.js.map
